module.exports = __webpack_public_path__ + "static/media/eth-logo.096e4ef2.png";